import { ArrowRight, Mail } from "lucide-react";
import { RevealOnScroll } from "./RevealText";
import { finalCtaEmail } from "../data/staticData";
import { useLanguage } from "../i18n/LanguageContext";

export function FinalCTA({ onOpenDemo }) {
  const { t } = useLanguage();
  const f = t.finalCta;
  return (
    <section id="final-cta" className="relative py-28 lg:py-36 bg-[#0A0A0C] overflow-hidden" data-testid="final-cta-section">
      <div className="absolute inset-0 grid-line opacity-30" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full bg-[#00F0FF]/10 blur-[130px]" />

      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center">
        <RevealOnScroll>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl text-white tracking-tighter leading-[1.02]">
            {f.title}
          </h2>
          <p className="mt-6 text-zinc-400 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed">
            {f.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={onOpenDemo}
              data-testid="final-cta-primary-button"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-md bg-[#00F0FF] text-black font-semibold hover:brightness-110 hover:scale-[1.03] transition-all duration-200"
            >
              {f.primaryCta}
              <ArrowRight className="w-4 h-4" />
            </button>
            <a
              href={`mailto:${finalCtaEmail}`}
              data-testid="final-cta-secondary-button"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-md border border-white/15 text-white font-semibold hover:border-[#00F0FF]/50 hover:text-[#00F0FF] transition-colors duration-200"
            >
              <Mail className="w-4 h-4" />
              {f.secondaryCta}
            </a>
          </div>

          <p className="mt-6 font-mono-data text-xs text-zinc-500">{f.footnote}</p>
        </RevealOnScroll>
      </div>
    </section>
  );
}
